import { __generator, __spreadArrays } from "tslib";
import { select, call, all, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../xhr';
import { withOffset as streamWithOffset } from '../../Stream';
import { getStream } from '../../Stream/base/selectors';
import { RECOMMENDED_TORPEDO_STREAM_ID, BROWSE_RFY_ENDPOINT, DEVIATIONS_PER_FETCH_COUNT, } from './constants';
import { initialize } from './actions';
/** Initializes the thread if needed and makes the first fetch */
export function handleInitialization() {
    var streamState, alreadyInited;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getStream, RECOMMENDED_TORPEDO_STREAM_ID)];
            case 1:
                streamState = _b.sent();
                alreadyInited = streamState.streamId && ((_a = streamState.items) === null || _a === void 0 ? void 0 : _a.length);
                if (alreadyInited || streamState.isFetching) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(streamWithOffset.actions.initialize({
                        streamId: RECOMMENDED_TORPEDO_STREAM_ID,
                        hasMore: true,
                        itemsPerFetch: DEVIATIONS_PER_FETCH_COUNT,
                    }))];
            case 2:
                _b.sent();
                return [4 /*yield*/, put(streamWithOffset.actions.fetch(RECOMMENDED_TORPEDO_STREAM_ID))];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
/** Fetches recommended stream from api with current offset */
export function handleStreamFetch(action) {
    var streamId, streamState, options, result, hasMore, nextOffset, items;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                streamId = action.streamId;
                if (streamId !== RECOMMENDED_TORPEDO_STREAM_ID) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, select(getStream, RECOMMENDED_TORPEDO_STREAM_ID)];
            case 1:
                streamState = _a.sent();
                options = {
                    url: BROWSE_RFY_ENDPOINT,
                    params: {
                        offset: streamState.nextOffset,
                    },
                };
                return [4 /*yield*/, call(request, options, fakeResponse)];
            case 2:
                result = _a.sent();
                if (!!result) return [3 /*break*/, 4];
                return [4 /*yield*/, put(streamWithOffset.actions.fetchFailure({
                        streamId: RECOMMENDED_TORPEDO_STREAM_ID,
                        errorMsg: 'Failed to get recommended deviations',
                    }))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                hasMore = result.hasMore, nextOffset = result.nextOffset, items = result.results;
                return [4 /*yield*/, put(streamWithOffset.actions.fetchSuccess({
                        streamId: RECOMMENDED_TORPEDO_STREAM_ID,
                        hasMore: hasMore,
                        nextOffset: nextOffset,
                        items: items,
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/** Mocked api call used in storybook */
function fakeResponse() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var deviationsByType = require('@wix/da-sample-data').deviationsByType;
        return {
            hasMore: true,
            nextOffset: 24,
            effectiveOrder: 'recommended',
            results: __spreadArrays(deviationsByType.image, deviationsByType.image, deviationsByType.image).slice(0, 24),
            orderOptions: {},
        };
    }
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initialize, handleInitialization),
                    takeEvery(streamWithOffset.actions.STREAM__WITH_OFFSET__FETCH, handleStreamFetch),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map